export class ArcAngelUser {
  arcAngelId?: string;
  permissions?: any;
  pro?: boolean;
  membership?: boolean;
  prime?: boolean;
  name: string = 'ArcAngel User';
  filtername?: string;
  email?: string;
  medical?: any;
  phone?: string;
  emergency_contacts: any[] = [];
  preferences?: any;
  userType?: string;
  devices: string[] = [];
  attributes?: any;
  organization?: any;

  constructor(data?: any) {
    if (data !== undefined) {
      this.arcAngelId = data.id;
      this.permissions = data.permissions;

      if (data.subscription) {
        this.pro = data.subscription.pro;
        this.membership = data.subscription.membership;
        this.prime = data.subscription.prime;
      }

      if (data.attributes) {
        if (data.attributes.firstName && data.attributes.firstName.length > 0) {
          this.name = data.attributes.firstName + ' ' + data.attributes.LastName;
          this.filtername = data.attributes.LastName;
        } else if (data.attributes.name && data.attributes.name.length > 0) {
          this.name = data.attributes.name;
          this.filtername = 'zz' + this.name;
        } else {
          this.name = 'ArcAngel User';
          this.filtername = 'zzz' + this.name;
        }
        this.email = data.attributes.email;
        this.medical = data.attributes.medical;
        if (data.attributes.phone && data.attributes.phone.number) {
          this.phone = data.attributes.phone.number;
        }
      } else {
        this.name = 'ArcAngel User';
      }

      this.preferences = data.preferences;
      if (data.attributes?.preferences?.userType) {
        this.userType = data.attributes.preferences.userType;
      } else if (data.preferences?.userType) {
        this.userType = data.preferences.userType;
      }

      if (data.installations) {
        for (const inst of data.installations) {
          this.devices.push(inst.id);
        }
      }

      this.attributes = data.attributes;
      this.organization = data.organizations?.[0];
    }
  }

  getId() { return this.arcAngelId; }
  getName() { return this.name; }
  setName(name: string) { this.name = name; }
  getEmail() { return this.email; }
  setEmail(email: string) { this.email = email; }
  getPermissions() { return this.permissions; }
  setPermissions(permissions: any) { this.permissions = permissions; }
  getDevices() { return this.devices; }
  setDevices(devices: string[]) { this.devices = devices; }
  getPhone() { return this.phone; }
  setPhone(phone: string) { this.phone = phone; }
  getPro() { return this.pro; }
  setPro(pro: boolean) { this.pro = pro; }
  getMembership() { return this.membership; }
  setMembership(membership: boolean) { this.membership = membership; }
  getPrime() { return this.prime; }
  setPrime(prime: boolean) { this.prime = prime; }
  getMedical() { return this.medical; }
  setMedical(medical: any) { this.medical = medical; }
  getEmergencyContacts() { return this.emergency_contacts;}
  getUserType() { return this.userType; }
  setUserType(userType: string) { this.userType = userType; }
  getAttributes() { return this.attributes; }
}